import React, { useEffect } from 'react';
import { ErrorMessage, useField } from 'formik';

interface IProps {
  children?: React.ReactNode;
  className?: string;
  name: string;
  onBlur?: () => void;
  onChange?: () => void;
  placeholder?: string;
  value?: string;
  type?: string;
  disabled?: boolean;
  readOnly?: boolean;
  maxLength?: number;
  regexp?: RegExp;
  setFieldValue?: (field: string, value: any, shouldValidate?: boolean) => void;
  addressType?: string;
  label?: string;
}

const FormikFormInput = (props: IProps) => {
  const { setFieldValue, addressType, label, ...inputProps } = props;
  const [field, meta, helpers] = useField(inputProps);
  const errorClass = `${meta.error && meta.touched ? 'is-invalid' : ''}`;
  const maxLength = props.maxLength ?? Number.MAX_SAFE_INTEGER;

  useEffect(() => {
    if (field.value?.length > maxLength) {
      helpers.setValue(field.value.slice(0, maxLength));
    }
  }, [field.value, helpers, maxLength]);

  return (
    <>
      <input
        {...field}
        {...inputProps}
        placeholder={props.placeholder}
        className={props.className + ' ' + errorClass}
        disabled={props.disabled}
        readOnly={props.readOnly}
        type={props.type ? props.type : 'text'}
        onChange={(event) => {
          if (event.target.value?.length > maxLength)
            event.target.value = event.target.value.slice(0, maxLength);
          if (props.regexp) {
            !props.regexp.test(event.target.value)
              ? event.preventDefault()
              : helpers.setValue(event.target.value);
          } else {
            helpers.setValue(event.target.value);
          }
        }}
      />
      {!props.regexp && meta.touched && meta.error && (
        <div className="invalid-feedback">
          {meta.error}
        </div>
      )}
    </>
  );
};

export default FormikFormInput;
